export interface IModelKnowledgeCategoryResponse {
  id: number;
  code: string;
  name: string;
  totalKM: number;
  uploadDate: string | Date;
  createdAt: string | Date;
  updatedAt: string | Date;
  createdByUser?: { username: string; email: string };
  updatedByUser?: { username: string; email: string };
}

export class ModelKnowledgeCategory {
  id: number;
  code: string;
  name: string;
  totalKM: number;
  createdAt: string | Date;
  updatedAt: string | Date;
  createdBy: string;
  updatedBy: string;
  uploadDate: string | Date;
  createdByUser: { username: string; email: string } | null;
  updatedByUser: { username: string; email: string } | null;
  createdByName: string;
  updatedByName: string;

  constructor(props = {} as IModelKnowledgeCategoryResponse) {
    props = props ?? {};
    this.id = props.id;
    this.code = props.code;
    this.name = props.name;
    this.totalKM = props.totalKM || 0;
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
    this.createdBy = '-';
    this.updatedBy = '-';
    this.uploadDate = props.uploadDate;
    this.createdByUser = props.createdByUser ?? null;
    this.updatedByUser = props.updatedByUser ?? null;
    this.createdByName = this.createdByUser ? this.createdByUser.username : '-';
    this.updatedByName = this.updatedByUser ? this.updatedByUser.username : '-';
  }
}

export interface IModelCreateKnowledgeCategoryRequest {
  name: string;
}

export interface IModelKnowledgeDocumentResponse {
  id: string;
  knowledgeId: string;
  fileName: string;
  originalFileName: string;
  filePath: string;
  fileSize: string | number;
  mimeType: string;
  fileExtension: string;
  status: string;
  processingStartedAt: string | Date | null;
  processingCompletedAt: string | Date | null;
  processingError: string | null;
  markdownContentPath: string | null;
  textContentPath: string | null;
  sourceGuide: string | null;
  keyTopics: any;
  metadata: any;
  vectorIds: any;
  chunkCount: number | null;
  createdAt: string | Date;
  createdBy: string | null;
  updatedAt: string | Date;
  updatedBy: string | null;
  deletedAt: string | Date | null;
}

export interface IModelKnowledgeLinkResponse {
  knowledgeId: string;
  url: string;
  title: string;
}

export class ModelKnowledgeDocument {
  id: string;
  knowledgeId: string;
  fileName: string;
  originalFileName: string;
  filePath: string;
  fileSize: string | number;
  mimeType: string;
  fileExtension: string;
  status: string;
  processingStartedAt: string | Date | null;
  processingCompletedAt: string | Date | null;
  processingError: string | null;
  markdownContentPath: string | null;
  textContentPath: string | null;
  sourceGuide: string | null;
  keyTopics: any;
  metadata: any;
  vectorIds: any;
  chunkCount: number | null;
  createdAt: string | Date;
  createdBy: string | null;
  updatedAt: string | Date;
  updatedBy: string | null;
  deletedAt: string | Date | null;

  constructor(props = {} as IModelKnowledgeDocumentResponse) {
    props = props ?? {};
    this.id = props.id || '';
    this.knowledgeId = props.knowledgeId || '';
    this.fileName = props.fileName || '';
    this.originalFileName = props.originalFileName || '';
    this.filePath = props.filePath || '';
    this.fileSize = props.fileSize || 0;
    this.mimeType = props.mimeType || '';
    this.fileExtension = props.fileExtension || '';
    this.status = props.status || '';
    this.processingStartedAt = props.processingStartedAt || null;
    this.processingCompletedAt = props.processingCompletedAt || null;
    this.processingError = props.processingError || null;
    this.markdownContentPath = props.markdownContentPath || null;
    this.textContentPath = props.textContentPath || null;
    this.sourceGuide = props.sourceGuide || null;
    this.keyTopics = props.keyTopics || null;
    this.metadata = props.metadata || null;
    this.vectorIds = props.vectorIds || null;
    this.chunkCount = props.chunkCount || null;
    this.createdAt = props.createdAt;
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt;
    this.updatedBy = props.updatedBy || null;
    this.deletedAt = props.deletedAt || null;
  }
}

export interface IModelKnowledgeDetailResponse {
  id: string;
  categoryId: string;
  code: string;
  name: string;
  description: string | null;
  type: string;
  processingMode: string | null;
  status: string;
  versionNumber: number;
  isLatestVersion: boolean;
  parentKnowledgeId: string | null;
  vectorStoreType: string | null;
  collectionName: string | null;
  embeddingModelName: string | null;
  documentChunkSize: number | null;
  documentChunkOverlap: number | null;
  vectorizedAt: string | Date | null;
  lastAppliedAt: string | Date | null;
  createdAt: string | Date;
  createdBy: string | null;
  updatedAt: string | Date;
  updatedBy: string | null;
  deletedAt: string | Date | null;
  comment: string | null;
  knowledgeDocuments?: IModelKnowledgeDocumentResponse;
  knowledgeLinks?: IModelKnowledgeLinkResponse;
  createdByUser?: { username: string; email: string };
  updatedByUser?: { username: string; email: string };
}

export class ModelKnowledgeDetail {
  id: string;
  categoryId: string;
  code: string;
  name: string;
  url: string;
  description: string | null;
  type: string;
  processingMode: string | null;
  status: string;
  versionNumber: number;
  isLatestVersion: boolean;
  parentKnowledgeId: string | null;
  vectorStoreType: string | null;
  collectionName: string | null;
  embeddingModelName: string | null;
  documentChunkSize: number | null;
  documentChunkOverlap: number | null;
  vectorizedAt: string | Date | null;
  lastAppliedAt: string | Date | null;
  createdAt: string | Date;
  createdBy: string | null;
  updatedAt: string | Date;
  updatedBy: string | null;
  deletedAt: string | Date | null;
  knowledgeDocuments?: ModelKnowledgeDocument;
  createdByUser: { username: string; email: string } | null;
  updatedByUser: { username: string; email: string } | null;
  createdByName: string;
  updatedByName: string;
  comment: string | null;

  constructor(props = {} as IModelKnowledgeDetailResponse) {
    props = props ?? {};
    this.id = props.id || '';
    this.categoryId = props.categoryId || '';
    this.code = props.code || '';
    this.name = props.name || '';
    this.url = props.knowledgeLinks ? props.knowledgeLinks.url : '';
    this.description = props.description || null;
    this.type = props.type || '';
    this.processingMode = props.processingMode || null;
    this.status = props.status || '';
    this.versionNumber = props.versionNumber || 1;
    this.isLatestVersion = props.isLatestVersion || false;
    this.parentKnowledgeId = props.parentKnowledgeId || null;
    this.vectorStoreType = props.vectorStoreType || null;
    this.collectionName = props.collectionName || null;
    this.embeddingModelName = props.embeddingModelName || null;
    this.documentChunkSize = props.documentChunkSize || null;
    this.documentChunkOverlap = props.documentChunkOverlap || null;
    this.vectorizedAt = props.vectorizedAt || null;
    this.lastAppliedAt = props.lastAppliedAt || null;
    this.createdAt = props.createdAt;
    this.createdBy = props.createdBy || '-';
    this.updatedAt = props.updatedAt;
    this.updatedBy = props.updatedBy || '-';
    this.deletedAt = props.deletedAt || null;
    this.createdByUser = props.createdByUser ?? null;
    this.updatedByUser = props.updatedByUser ?? null;
    this.createdByName = this.createdByUser ? this.createdByUser.username : '-';
    this.updatedByName = this.updatedByUser ? this.updatedByUser.username : '-';
    this.comment = props.comment || null;
    this.knowledgeDocuments = props.knowledgeDocuments
      ? new ModelKnowledgeDocument(props.knowledgeDocuments)
      : undefined;
  }
}

export interface IModelApplyFileStatusResponse {
  categoryId: string;
  processing: number;
  live: number;
  draft: number;
  failed: number;
  total: number;
}

export class ModelApplyFileStatus {
  categoryId: string;
  processing: number;
  live: number;
  draft: number;
  failed: number;
  total: number;

  constructor(props = {} as IModelApplyFileStatusResponse) {
    props = props ?? {};
    this.categoryId = props.categoryId || '';
    this.processing = props.processing || 0;
    this.live = props.live || 0;
    this.draft = props.draft || 0;
    this.failed = props.failed || 0;
    this.total = props.total || 0;
  }
}

export interface IModelSaveLinkItem {
  url: string;
  title: string;
}

export interface IModelSaveLinkRequest {
  categoryId: string;
  type: string;
  links: IModelSaveLinkItem[];
}

export class ModelSaveLinkRequest {
  categoryId: string;
  type: string;
  links: IModelSaveLinkItem[];

  constructor(props = {} as IModelSaveLinkRequest) {
    props = props ?? {};
    this.categoryId = props.categoryId || '';
    this.type = props.type || 'markdown';
    this.links = Array.isArray(props.links) ? props.links : [];
  }
}

export interface IModelSaveLinkItemResponse {
  knowledgeId: string;
  code: string;
  url: string;
}

export interface IModelSaveLinkResponse {
  items: IModelSaveLinkItemResponse[];
}

export class ModelSaveLinkItem {
  knowledgeId: string;
  code: string;
  url: string;

  constructor(props = {} as IModelSaveLinkItemResponse) {
    props = props ?? {};
    this.knowledgeId = props.knowledgeId || '';
    this.code = props.code || '';
    this.url = props.url || '';
  }
}

export class ModelSaveLink {
  items: ModelSaveLinkItem[];

  constructor(props = {} as IModelSaveLinkResponse) {
    props = props ?? {};
    this.items = Array.isArray(props.items)
      ? props.items.map((item) => new ModelSaveLinkItem(item))
      : [];
  }
}

export interface IModelValidateLinkRequest {
  link: string;
  type: string;
}

export interface IModelValidateLinkResponse {
  isValid: boolean;
  isDuplicate: boolean;
  title: string;
  content: string;
  error: string;
}

export class ModelValidateLink {
  isValid: boolean;
  isDuplicate: boolean;
  title: string;
  content: string;
  error: string;

  constructor(props = {} as IModelValidateLinkResponse) {
    props = props ?? {};
    this.isValid = props.isValid || false;
    this.isDuplicate = props.isDuplicate || false;
    this.title = props.title || '';
    this.content = props.content || '';
    this.error = props.error || '';
  }
}
